$(document).ready(function() {
  
  $('#etiquette-filters .etfilter[data-tagsorder]').each(function(i, etfilter) {
    var $etfilter = $(etfilter),
        tagsorder = $etfilter.attr('data-tagsorder').split(','),
        $etfilter_ul = $etfilter.find('ul'),
        $etfilter_lis = $etfilter_ul.find('li'),
        $corrected_lis = [];
    $.each(tagsorder, function(i, ordtag) {
      var $li = $.grep($etfilter_lis, function(item, i) { return ($(item).find('label').html().trim().toLowerCase() == ordtag.toLowerCase()); });
      if($li.length > 0)
        $corrected_lis = $corrected_lis.concat($li);
    });
    $etfilter_ul.html($corrected_lis);
  });
  
});

var $filter_wrap, $items_wrap, $more_wraps, $count_displays;
function etiquette_filters_init() {
  
  // Init element vars
  $filter_wrap = $('#etiquette-filters[data-collectionurl]');
  if($filter_wrap.length == 0) { console.log('Filters are disabled on this page.'); return; }
  $items_wrap = $($filter_wrap.attr('data-for'));
  $more_wraps = $items_wrap.siblings('.grid-load-more');
  $count_displays = $('.filtered-prod-count');
  
  // Identify active filters from URL on page load
  var current_url = parse_url(window.location.href),
      current_base_url = current_url.protocol+'//'+current_url.hostname+current_url.pathname,
      active_tags = current_base_url.replace($filter_wrap.attr('data-collectionurl'), '').replace(/\//g, ''),
      active_pseudotags = [],
      active_sorting = current_url.search.length > 1 ? current_url.search.replace('?', '').split('&') : [];
  active_tags = active_tags ? active_tags.split('+').filter(function(item) { return item.indexOf('https:') < 0 }) : [];
  $.each(active_tags, function(i, active_tag) {
    if(active_tag.indexOf('filter--') > -1) {
      active_pseudotags = active_tag.replace('filter--', '').split('--');
      active_tags.splice(i, 1);
    }
  });
  active_sorting = $.grep(active_sorting, function(item) { return (item.indexOf('sort_by=') > -1); });
  if(active_tags.length > 0
  || active_pseudotags.length > 0
  || active_sorting.length > 0) {
    $('body').addClass('coll-filters-active');
    $('#etiquette-filters input[type="checkbox"][data-taghandle]').prop('checked', false);
    $.each(active_tags, function(i, active_tag) {
      $('#etiquette-filters input[type="checkbox"][data-taghandle="'+active_tag+'"]').prop('checked', true);
    });
    $('#etiquette-filters input[type="checkbox"][data-hashhandle][data-tags]').prop('checked', false);
    $.each(active_pseudotags, function(i, active_pseudotag) {
      $('#etiquette-filters input[type="checkbox"][data-hashhandle="'+active_pseudotag+'"][data-tags]').prop('checked', true);
    });
    $.each(active_sorting, function(i, active_sorting_param) {
      active_sorting_param = active_sorting_param.split('=');
      if(active_sorting_param[0] == 'sort_by')
        $('#etiquette-filters input[type="checkbox"][data-taghandle="'+active_sorting_param[1]+'"]').prop('checked', true);
    });
  }
  
  // Handle events
  $('#etiquette-filters[data-collectionurl]')
  .on('click', '.etfilter input[type="checkbox"]', function(e) {
    var base_url = $filter_wrap.attr('data-collectionurl').replace(/\/$/, ''),
        tags = [],
        pseudotags = [],
        $previously_checked_sort_by_filter = $filter_wrap.find('.etfilter.sort-by input[type="checkbox"][data-taghandle]:checked');
    if($filter_wrap.hasClass('loading')) return;
    if($(e.target).closest('.etfilter.sort-by').length > 0) {
      $previously_checked_sort_by_filter.not($(this)).prop('checked', false);
      if($items_wrap.hasClass('end-reached')) {
        eqfilt_sort_items($(this).prop('checked') == true ? $(this).attr('data-taghandle') : 'none');
        window._defer_statechange = true;
        var current_url = parse_url(window.location.href),
            current_search = $(this).prop('checked') == true ? '?sort_by='+$(this).attr('data-taghandle') : '';
        History.replaceState(null, document.title, current_url.protocol+'//'+current_url.hostname+current_url.pathname+current_search);
        window._defer_statechange = null;
        return;
      }
    }
    var sort_by = $filter_wrap.find('.etfilter.sort-by input[type="checkbox"][data-taghandle]:checked').eq(0).length > 0 ? $filter_wrap.find('.etfilter.sort-by input[type="checkbox"][data-taghandle]:checked').eq(0).attr('data-taghandle') : '';
    if($(this).is('input[type="checkbox"][data-taghandle]'))
      $(this).closest('.etfilter').find('input[type="checkbox"][data-taghandle]').not($(this)).prop('checked', false);
    $filter_wrap.find('.etfilter[class*="filter-"] input[type="checkbox"][data-taghandle]:checked').each(function(i, checkbox) {
      tags.push($(checkbox).attr('data-taghandle'));
    });
    $filter_wrap.find('.etfilter[class*="filter-"] input[type="checkbox"][data-hashhandle][data-tags]:checked').each(function(i, checkbox) {
      pseudotags.push(($(checkbox).closest('.etfilter').hasClass('filter-color') ? 'color:' : '')+$(checkbox).attr('data-hashhandle')+':'+$(checkbox).attr('data-tags'));
    });
    eqfilt_start_filtering($filter_wrap.attr('data-collectionurl'), tags, pseudotags, sort_by); 
  });
  $('.clear-all-filters').unbind().click(function(e) {
    e.preventDefault();
    if(!$('#etiquette-filters').hasClass('loading')) {
      $('#etiquette-filters input[type="checkbox"][data-taghandle], input[type="checkbox"][data-hashhandle][data-tags]').prop('checked', false);
      window_location($filter_wrap.attr('data-collectionurl'), 'Clearing filters...', true, 'replace'); //eqfilt_start_filtering($filter_wrap.attr('data-collectionurl'), [], {}, '');
    }
  });
  $('#etiquette-filters .etfilter h4').unbind().click(function(e) {
    $(this).closest('.etfilter').addClass('mobile-open').siblings('.etfilter').removeClass('mobile-open');
  });
  
  // if pseudotag detected in url, trigger an update
  if(active_pseudotags.length > 0) {
    $('body').addClass('etiquette-filters-open');
    var $a_checked_pseudotag = $('#etiquette-filters input[type="checkbox"][data-hashhandle][data-tags]:checked').eq(0);
    $a_checked_pseudotag.prop('checked', false);
    window._init_filters_on_page_load = true;
    $a_checked_pseudotag.trigger('click');
  }
  
} /* etiquette_filters_init */

function eqfilt_start_filtering(url, tags, pseudotags, sort_by) {
  $('body').removeClass('has-collection-hero past-collection-hero').addClass('filtering-products').find('#content .has-collection-hero').empty().remove();
  $items_wrap.add($filter_wrap).add($more_wraps).removeClass('end-reached').addClass('loading');
  $filter_wrap.find('input[type="checkbox"][data-taghandle], input[type="checkbox"][data-hashhandle][data-tags]').prop('disabled', true);
  $items_wrap.children('.row').empty();
  window._eqfilt_url = url;
  window._eqfilt_tags = tags;
  window._eqfilt_color_pseudotags = [];
  $.each($.grep(pseudotags, function(item) { return item.indexOf('color:') > -1; }).map(function(item) { return item.replace('color:', ''); }), function(i, item) {
    window._eqfilt_color_pseudotags = window._eqfilt_color_pseudotags.concat(item.split(':')[1].split(','));
  });
  window._eqfilt_pseudotags = $.grep(pseudotags, function(item) { return item.indexOf('color:') < 0; });
  window._eqfilt_sort_by = sort_by;
  window._eqfilt_page = 0;
  window._eqfilt_max_page = 10;
  window._eqfilt_results = [];
  window._eqfilt_result_ids = [];
  window._eqfilt_requests = [];
  window._eqfilt_request_index = 0;
  if(pseudotags.length > 0) {
    var eqfilt_pseudotags = $.map(window._eqfilt_pseudotags, function(pseudotag, i) { return pseudotag.split(':')[0]; });
    if(window._eqfilt_color_pseudotags.length > 0) {
      $.each(window._eqfilt_color_pseudotags, function(j, pseudotag_sub_tag) {
        pseudotag_sub_tag = pseudotag_sub_tag.toLowerCase().replace(/\s\s+/g, ' ').replace(/ /g, '-').replace(/[^a-zA-Z0-9\-]/g, '');
        window._eqfilt_requests.push(window._eqfilt_url+'/'+(window._eqfilt_tags.length > 0 ? window._eqfilt_tags.join('+')+'+' : '')+pseudotag_sub_tag+(eqfilt_pseudotags.length > 0 ? '+'+eqfilt_pseudotags.join('+') : '')+(window._eqfilt_sort_by ? '?sort_by='+window._eqfilt_sort_by : ''));
      });
    } else {
      window._eqfilt_requests.push(window._eqfilt_url+'/'+(window._eqfilt_tags.length > 0 ? window._eqfilt_tags.join('+')+'+' : '')+(eqfilt_pseudotags.length > 0 ? eqfilt_pseudotags.join('+') : '')+(window._eqfilt_sort_by ? '?sort_by='+window._eqfilt_sort_by : ''));
    }
  } else
    window._eqfilt_requests.push(window._eqfilt_url+'/'+(window._eqfilt_tags.length > 0 ? window._eqfilt_tags.join('+') : '')+(window._eqfilt_sort_by ? '?sort_by='+window._eqfilt_sort_by : ''));
  eqfilt_load_full_collection();
}
function eqfilt_load_full_collection() {
  window._eqfilt_page++;
  if(window._eqfilt_page >= window._eqfilt_max_page) {
    window._eqfilt_request_index++;
    window._eqfilt_page = 1;
  }
  if(window._eqfilt_request_index >= window._eqfilt_requests.length)
    eqfilt_filtering_complete();
  else {
    var next_url = window._eqfilt_requests[window._eqfilt_request_index];
    if(window._eqfilt_page > 1)
      next_url = next_url+(next_url.indexOf('?') > -1 ? '&' : '?')+'page='+window._eqfilt_page;
    eqfilt_load_collection_page(next_url, window._eqfilt_page);
  }
}
function eqfilt_load_collection_page(coll_page_url, page_num) {
  if(coll_page_url) {
    var $filter_wrap = $('#etiquette-filters'),
        items_selector = $filter_wrap.attr('data-items'),
        $items_wrap = $($filter_wrap.attr('data-for'));
    $.ajax({
      url: coll_page_url,
	  method: 'GET',
	  dataType: 'html',
      context: $items_wrap
    }).done(function(response) {
      response = String(response)
	    .replace(/<\!DOCTYPE[^>]*>/i, '')
	    .replace(/<(html|head|body|title|meta|script)([\s\>])/gi, '<div data-elementtype="document-$1"$2')
	    .replace(/<\/(html|head|body|title|meta|script)\>/gi, '</div>');
	  response = $.trim(response);
	  var $response_html = $(response),
	      $response_body = $response_html.find('[data-elementtype="document-body"]:first'),
	      $items = $response_body.find($filter_wrap.attr('data-for')+' '+items_selector),
	      $color_filters = $response_body.find('#etiquette-filters .etfilter.filter-color'),
	      $color_filter_items = $color_filters.find('ul li');
	  // display items
	  if($items.length > 0) {
	    if($items_wrap.find(items_selector).length == 0)
	      $items_wrap.children('.row').append($items);
	    else {
	      $items.each(function(i, item) {
	        if($items_wrap.find('[data-productid="'+$(item).attr('data-productid')+'"]').length == 0)
  	          $items_wrap.find(items_selector).last().parent().append($(item));
	      });
	    }
	  } else {
	    window._eqfilt_page = window._eqfilt_max_page;
	  }
    }).fail(function(error) {
      
    }).always(function() {
      eqfilt_load_full_collection();
    });
  }
}

function eqfilt_filtering_complete() {
  $items_wrap.add($filter_wrap).add($more_wraps).removeClass('loading').addClass('end-reached');
  $filter_wrap.find('input[type="checkbox"][data-taghandle], input[type="checkbox"][data-hashhandle][data-tags]').prop('disabled', false);
  var count_items = $items_wrap.find('.collection-grid-item').length;
  $('.filtered-prod-count').attr('data-filteredprodcount', count_items);
  $('body').removeClass('filtering-products').delay(500).promise().done(function() { if(typeof(window['adjust_filters_height']) != 'undefined') adjust_filters_height(); });
  if(window._eqfilt_tags.length > 0
  || window._eqfilt_sort_by != ''
  || window._eqfilt_pseudotags.length > 0
  || window._eqfilt_color_pseudotags.length > 0)
    $('body').addClass('coll-filters-active');
  else
    $('body').removeClass('coll-filters-active');
  // sort items
  if(window._eqfilt_sort_by != '') {
    eqfilt_sort_items(window._eqfilt_sort_by);
  }
  if(count_items > 0) {
    collection_adjust_items();
  } else {
    $items_wrap.children('.row').html('<div class="col-xs-12 no-items-to-show"><p>No items to show.</p><p>Please try a different set of filters, explore another collection<br>or start over at <a href="/">our homepage</a>.</p></div>');
  }
  // Update browser History
  var guessed_collection_title = 'Items',
      filter_tag_names = window._eqfilt_tags;
	  u = parse_url(window.location.href),
	  tags_suffix = (window._eqfilt_tags.length > 0 ? window._eqfilt_tags.join('+') : ''),
	  filtered_collection_url = window._eqfilt_url+'/'+tags_suffix+'[PSEUDOTAGS]'+(window._eqfilt_sort_by ? '?sort_by='+window._eqfilt_sort_by : ''),
	  pseudotags_tag = '';
  if(u.pathname.indexOf('/collections') > -1) {
	guessed_collection_title = u.pathname.split('/')[2];
	guessed_collection_title = guessed_collection_title.replace(/-/g, ' ').replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  }
  if(window._eqfilt_pseudotags.length > 0) {
    $.each(window._eqfilt_pseudotags, function(i, pseudotag) {
      pseudotag = pseudotag.split(':');
      pseudotags_tag += (pseudotags_tag.indexOf('filter--') > -1 ? '' : 'filter')+'--'+pseudotag[0];
      filter_tag_names.push(pseudotag[0]);
    });
  }
  if(window._eqfilt_color_pseudotags.length > 0) {
    $.each(window._eqfilt_color_pseudotags, function(i, pseudotag) {
      pseudotags_tag += (pseudotags_tag.indexOf('filter--') > -1 ? '' : 'filter')+'--'+pseudotag.toLowerCase().replace(/ /g, '-');
      filter_tag_names.push(pseudotag);
    });
  }
  filtered_collection_url = filtered_collection_url.replace('[PSEUDOTAGS]', (tags_suffix.length > 0 ? '+' : '')+pseudotags_tag);
  window._defer_statechange = true;
  History.replaceState(null, guessed_collection_title+(filter_tag_names.length > 0 ? ' – filter "'+filter_tag_names.join(', ')+'"' : '')+' – '+SHOP.name, filtered_collection_url);
  window._defer_statechange = null;
  $('body #heading-banner #page-heading').html(
    filter_tag_names.length > 0
    ? '<a href="'+$('#etiquette-filters[data-collectionurl]').attr('data-collectionurl')+'">'+$('#etiquette-filters[data-collectiontitle]').attr('data-collectiontitle')+'</a> - '+count_items+' Filter Result'+(count_items == 1 ? '' : 's')
    : $('#etiquette-filters[data-collectiontitle]').attr('data-collectiontitle')
  );
}

function eqfilt_sort_items(sort_by) {
  var items_selector = jQuery.grep($filter_wrap.attr('data-items').split(','), function(item, i) { return (item != "[id^='page-anchor-']"); });
  if($items_wrap.find(items_selector.join(',')).length == 0) return;
  if($items_wrap.find(items_selector.join(',')).filter('[data-initpos]').length == 0) {
    $items_wrap.find(items_selector.join(',')).each(function(i, item) { $(item).attr('data-initpos', (i + 1)); });
  }
  $items_wrap.find(items_selector.join(',')).sort(function(a, b) {
    switch(sort_by) {
      case 'created-descending':
        var val_a = new Date($(a).attr('data-published')).getTime(),
            val_b = new Date($(b).attr('data-published')).getTime();
        return val_a < val_b ? 1 : (val_a > val_b ? -1 : 0);
      break;
      case 'price-descending':
        var val_a = parseFloat($(a).find('.price .money').html().replace(/[^\d.-]/g, '')),
            val_b = parseFloat($(b).find('.price .money').html().replace(/[^\d.-]/g, ''));
        return val_a < val_b ? 1 : (val_a > val_b ? -1 : 0);
      break;
      case 'price-ascending':
        var val_a = parseFloat($(a).find('.price .money').html().replace(/[^\d.-]/g, '')),
            val_b = parseFloat($(b).find('.price .money').html().replace(/[^\d.-]/g, ''));
        return val_a > val_b ? 1 : (val_a < val_b ? -1 : 0);
      break;
      case 'title-descending':
        var val_a = $(a).find('.name').html(),
            val_b = $(b).find('.name').html();
        return val_a < val_b ? 1 : (val_a > val_b ? -1 : 0);
      break;
      case 'title-ascending':
        var val_a = $(a).find('.name').html(),
            val_b = $(b).find('.name').html();
        return val_a > val_b ? 1 : (val_a < val_b ? -1 : 0);
      break;
      default:
        var val_a = new Date($(a).attr('data-published')).getTime(),
            val_b = new Date($(b).attr('data-published')).getTime();
        return val_a > val_b ? 1 : (val_a < val_b ? -1 : 0);
    }
  }).appendTo($items_wrap.find('.row'));
  $items_wrap.find('[id^="page-anchor-"]').empty().remove();
  var page_index = 0,
      page_size = parseInt($items_wrap.attr('data-pagesize'));
  $items_wrap.find(items_selector.join(',')).each(function(i, item) {
    if((i % page_size) == 0)
      $(item).before('<div id="page-anchor-'+(++page_index)+'" />');
  });
}